import platform from 'platform';
import { toast } from 'chameleon/ui-stack/ui/toast';
import isNil from 'lodash/isNil';

const listClasses = (classList) =>
  classList
    .map((classItem) => `${classItem.name} - ID ${classItem.id}`)
    .join(', ');

const listSubjects = (list) =>
  list
    .map((subjectItem) => {
      const classes = subjectItem.classes
        ? ` (${listClasses(subjectItem.classes)})`
        : '';
      return `${subjectItem.name}${classes}`;
    })
    .join(', ');

const createContactUsRequest = (url, body) => {
  const onError = () => {
    const message = `Error while sending mail`;
    toast.error(message);
  };
  return fetch(url, { method: 'POST', body })
    .then((response) => {
      if (response.ok) {
        toast('Your message has been sent!');
      } else {
        onError();
      }
    })
    .catch((error) => {
      onError();
      throw new Error(error);
    });
};

const sendMessage = async (formData, uploadedFiles, userData, subjectData) => {
  const { me } = userData;
  const postData = new FormData();

  const {
    isTeacher,
    schoolSet,
    userRole,
    email,
    username,
    ssoLogin,
    importId,
    id,
    initId,
    firstName,
    lastName,
  } = me;

  const schools = schoolSet.map((school) => school.name).join(', ');
  const roles = userRole.join(', ');
  const parsedEmail = email.split('|');
  const contactUrl = `${CB_LEGACY_URL}/n/contact/preap2018teachers`;

  let userSubjects = listSubjects(
    isTeacher ? userData.teacherSubjects : userData.adminSubjects,
  );

  const { name: subjectName } = subjectData;

  const body = {
    //Form related
    description: formData.description,
    subject: `${formData.issueType} - ${formData.subject}`,
    isInstitutionalDevice: formData.isInstitutionalDevice,

    // Email related
    email: parsedEmail[parsedEmail.length - 1],
    username,
    first_name: firstName,
    last_name: lastName,
    roles,
    schools,
    sso_login: ssoLogin,
    // Subjects section
    current_subject: subjectName || 'No subject yet selected',
    subjects: userSubjects,
    // IDs section
    import_id: importId,
    user_id: id,
    finetune_user_id: initId,
    // Browser Related
    browser_name: platform.name,
    browser_version: platform.version,
    mobile_device: platform.product || 'No mobile',
    mobile_manufacturer: platform.manufacturer || 'No mobile',
    operating_system: platform.os,
    contacted_from_url: window.location.href,
  };

  for (let field in body) {
    if (!isNil(body[field])) {
      postData.set(field, body[field]);
    }
  }

  if (uploadedFiles?.length > 0) {
    for (let i = 0; i < uploadedFiles.length; i++) {
      postData.append(`file_upload${i}`, uploadedFiles[i]);
    }
  }

  await createContactUsRequest(contactUrl, postData);
};

export default sendMessage;
